import { useLocation, useNavigate } from 'react-router-dom';
import AuthCard from '../components/AuthCard';

export default function ForgotSent() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const email = state?.email || 'din email';

  return (
    <AuthCard>
      <div className="sent-wrapper">
        <div className="sent-icon">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
            <polyline points="22,6 12,13 2,6"/>
          </svg>
        </div>

        <h1 className="page-title">Tjek din indbakke</h1>

        <p className="sent-desc">
          Vi har sendt et nulstillingslink til
        </p>
        <p className="sent-email">{email}</p>

        <div className="sent-steps">
          <div className="sent-step">
            <div className="step-num">1</div>
            <span>Åbn emailen fra Membify</span>
          </div>
          <div className="sent-step">
            <div className="step-num">2</div>
            <span>Klik på linket i emailen</span>
          </div>
          <div className="sent-step">
            <div className="step-num">3</div>
            <span>Vælg en ny adgangskode</span>
          </div>
        </div>

        <p className="sent-note">
          Linket udløber om 30 minutter. Tjek evt. din spam-mappe.
        </p>

        <button
          className="login-btn"
          style={{ marginTop: '8px' }}
          onClick={() => navigate('/')}
        >
          Tilbage til log ind
        </button>

        <button
          className="resend-btn"
          type="button"
          onClick={() => navigate('/forgot')}
        >
          Send linket igen
        </button>
      </div>
    </AuthCard>
  );
}
